// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-group-page__item[data-v-1038ee8d] {\n  white-space: nowrap;\n}\n[data-v-1038ee8d] .v-data-table thead th {\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
